import { render, staticRenderFns } from "./OverFlowDialog.vue?vue&type=template&id=19303c5d&scoped=true"
import script from "./OverFlowDialog.vue?vue&type=script&lang=ts"
export * from "./OverFlowDialog.vue?vue&type=script&lang=ts"
import style0 from "./OverFlowDialog.vue?vue&type=style&index=0&id=19303c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19303c5d",
  null
  
)

export default component.exports